export default __webpack_public_path__ + "static/media/gournay17.08a16025.jpg";